import { Language } from 'cf-grpc/creativefabrica/content/v1/types_pb'
import { Language as ContentDeliveryLanguage } from 'cf-grpc/creativefabrica/content/v2/types_pb'
import { Language as GQLLanguage } from 'codegen/types'

export const mapToContentLanguage = new Map<GQLLanguage, Language>([
  [GQLLanguage.En, Language.EN],
  [GQLLanguage.Es, Language.ES],
  [GQLLanguage.De, Language.DE],
  [GQLLanguage.Fr, Language.FR],
  [GQLLanguage.It, Language.IT],
  [GQLLanguage.Nl, Language.NL],
  [GQLLanguage.Pt, Language.PT_BR],
  [GQLLanguage.Pl, Language.PL],
])

export const mapToContentDeliveryLanguage = new Map<GQLLanguage, ContentDeliveryLanguage>([
  [GQLLanguage.En, ContentDeliveryLanguage.EN],
  [GQLLanguage.Es, ContentDeliveryLanguage.ES],
  [GQLLanguage.De, ContentDeliveryLanguage.DE],
  [GQLLanguage.Fr, ContentDeliveryLanguage.FR],
  [GQLLanguage.It, ContentDeliveryLanguage.IT],
  [GQLLanguage.Nl, ContentDeliveryLanguage.NL],
  [GQLLanguage.Pt, ContentDeliveryLanguage.PT_BR],
  [GQLLanguage.Pl, ContentDeliveryLanguage.PL],
])

export const mapFromContentLanguage = new Map<Language, GQLLanguage>([
  [Language.EN, GQLLanguage.En],
  [Language.ES, GQLLanguage.Es],
  [Language.DE, GQLLanguage.De],
  [Language.FR, GQLLanguage.Fr],
  [Language.IT, GQLLanguage.It],
  [Language.NL, GQLLanguage.Nl],
  [Language.PT_BR, GQLLanguage.Pt],
  [Language.PL, GQLLanguage.Pl],
])
